export default [
    {
        path: "/admin/leave-initial-balances",
        name: "leave-initial-balance",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/leave-initial-balance")
    }
];
